import { IImageStyles } from '@fluentui/react';
import { IPImage } from 'baseComponents';
import { IPImageFit } from 'baseComponents/Image/IPImage';
import Config from 'services/Config/configService';

type AIIconProps = {
  inactive?: boolean;
  size?: number;
};

export const AIIcon = (props: AIIconProps) => {
  const size = props.size ?? 18;

  const imageStyles: Partial<IImageStyles> = {
    root: {
      display: 'block',
      opacity: props.inactive ? 0.55 : 1,
    },
  };

  return (
    <IPImage
      alt=""
      height={size}
      imageFit={IPImageFit.centerContain}
      src={`${Config.getImageURL()}/ai-icon.svg`}
      styles={imageStyles}
      width={size}
    />
  );
};
